import React from "react";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
  Paper,
  makeStyles,
} from "@material-ui/core";

import { MtuUsageByMonthData, mtuUsageTableTitles } from "../types";

export type MtuTableProps = {
  data: MtuUsageByMonthData[];
};

const useStyles = makeStyles(() => ({
  tableCell: {
    fontSize: "0.8rem",
  },
}));

export const MtuTable = ({ data }: MtuTableProps) => {
  const classes = useStyles();

  const keys = Object.keys(data[0]);

  // The first 2 keys are "year" and "month". We don't need those in the table.
  const dataTransposed = keys
    .map((key) => {
      return data.map((obj) => obj[key]);
    })
    .slice(2);

  // Adding title intto first column each row for displaying in the table.
  const dataTransposedWithTitles: string[][] = dataTransposed.map(
    (row, rowIndex) => {
      return [mtuUsageTableTitles[rowIndex], ...row];
    }
  );
  const headers = dataTransposedWithTitles[0] || [];
  const bodyData = dataTransposedWithTitles.slice(1);
  return (
    <Paper>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell key={index}>
                  <Typography variant="h6">{header}</Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {bodyData.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {row.map((val, valIndex) => (
                  <TableCell
                    key={`mtu-table-row-${valIndex}`}
                    className={classes.tableCell}
                  >
                    {val.toLocaleString()}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
